import {Collapse} from "@kunukn/react-collapse";
import cx from "classnames";

const CollapseElement = ({isOpen = false, className = "section-collapse", title, toggle, children} : {isOpen: boolean, className?: string, toggle: any, children: any, title: string}) => {

    return (
        <div className={className}>
            <button
                className={cx('app-collapse__toggle', {'app-collapse__toggle--active': isOpen})}
                onClick={toggle}
            >
                <span className="app-collapse__toggle-text">{title}</span>
                <div className="rotate90">
                    <svg className={cx('icon-collapse', { 'icon-collapse--expanded': isOpen })} xmlns="http://www.w3.org/2000/svg" width="16.635" height="10.959" viewBox="0 0 16.635 10.959"><g id="arrow-down" transform="translate(-258.879 79.338) rotate(-90)"><line id="Ligne_11" x1="6.717" y2="6.717" transform="translate(70.5 261)" fill="none" stroke="#fff" strokeLinecap="round" strokeWidth="3"></line><line id="Ligne_12"  x1="6.717" y1="5.683" transform="translate(70.5 267.717)" fill="none" stroke="#fff" strokeLinecap="round" strokeWidth="3"></line></g></svg>
                </div>
            </button>
            <Collapse
                isOpen={isOpen}
                className={
                    'app-collapse__collapse app-collapse__collapse--gradient ' +
                    (isOpen ? 'app-collapse__collapse--active' : '')
                }
            >
                <div className="app-collapse__content">
                    {children}
                </div>
            </Collapse>
        </div>
    )
}


export default CollapseElement
